export { createWebAuthRedirect } from './auth-redirect.ts';
export type { WebAuthRedirectOptions } from './auth-redirect.ts';
export { createWebDevice } from './device.ts';
export type { DeviceWindow } from './device.ts';
export { createWebStorage } from './storage.ts';
export type { StorageLike, WebStorageOptions } from './storage.ts';
export {
  CURRENT_PROGRESS_VERSION,
  createLocalProgressRepo,
  progressKey,
} from './local-progress-repo.ts';
export type { LocalProgressRepoOptions, Migration } from './local-progress-repo.ts';

export const PACKAGE = '@dcs/platform/web';
